import {
  BUSINESS_CATEGORY_EEM,
  BUSINESS_CATEGORY_PROVIDER,
  BUSINESS_STATUS_PRIVATE,
  BUSINESS_STATUS_PUBLIC,
  BUSINESS_USER_TYPE_BUSINESS_ADMIN,
  BUSINESS_USER_TYPE_BUSINESS_EDITOR,
  BUSINESS_USER_TYPE_GLOBAL_EDITOR,
  BUSINESS_USER_TYPE_PROJECT_EDITOR,
  INDICATOR_STATUS_TODO,
  INDICATOR_STATUS_IN_PROGRESS,
  INDICATOR_STATUS_DONE,
  INDICATOR_STATUS_NOT_APPLICABLE,
  INDICATOR_STATUS_OVERRIDE_NEVER_APPLICABLE,
  INDICATOR_DIFFICULTY_UNSET,
  INDICATOR_DIFFICULTY_EASY,
  INDICATOR_DIFFICULTY_MEDIUM,
  INDICATOR_DIFFICULTY_HARD,
  INDICATOR_TARGET_DATE_UNSET,
  INDICATOR_TARGET_DATE_LATE,
  INDICATOR_TARGET_DATE_UPCOMING,
  PROJECT_STATUS_ACTIVE,
  PROJECT_STATUS_INACTIVE,
  PROJECT_STATUS_FINISH,
  USER_LANGUAGE_FRENCH,
  USER_LANGUAGE_ENGLISH
} from '@/consts/enums'
import i18n from '@/helpers/i18n'

function formatBusinessStatus(status) {
  switch (status) {
    case BUSINESS_STATUS_PRIVATE:
      return i18n.t('business-status-private-text')
    case BUSINESS_STATUS_PUBLIC:
      return i18n.t('business-status-public-text')
    default:
      return status
  }
}

function formatBusinessCategory(category) {
  switch (category) {
    case BUSINESS_CATEGORY_EEM:
      return i18n.t('business-type-mining-text')
    case BUSINESS_CATEGORY_PROVIDER:
      return i18n.t('business-type-provider-text')
    default:
      return category
  }
}

function formatBusinessUserType(businessUserType) {
  switch (businessUserType) {
    case BUSINESS_USER_TYPE_BUSINESS_ADMIN:
      return i18n.t('business-user-type-business-admin')
    case BUSINESS_USER_TYPE_GLOBAL_EDITOR:
      return i18n.t('business-user-type-global-editor')
    case BUSINESS_USER_TYPE_BUSINESS_EDITOR:
      return i18n.t('business-user-type-business-editor')
    case BUSINESS_USER_TYPE_PROJECT_EDITOR:
      return i18n.t('business-user-type-project-editor')
    default:
      return businessUserType
  }
}

function formatIndicatorStatus(status) {
  switch (status) {
    case INDICATOR_STATUS_TODO:
      return i18n.t('indicator-status-TODO')
    case INDICATOR_STATUS_IN_PROGRESS:
      return i18n.t('indicator-status-IN_PROGRESS')
    case INDICATOR_STATUS_DONE:
      return i18n.t('indicator-status-DONE')
    case INDICATOR_STATUS_NOT_APPLICABLE:
      return i18n.t('indicator-status-NOT_APPLICABLE')
    case INDICATOR_STATUS_OVERRIDE_NEVER_APPLICABLE:
      return i18n.t('indicator-status-OVERRIDE_NEVER_APPLICABLE')
    default:
      return status
  }
}

function formatIndicatorTargetDate(targetDateType) {
  switch (targetDateType) {
    case INDICATOR_TARGET_DATE_UNSET:
      return i18n.t('indicator-target-date-UNSET')
    case INDICATOR_TARGET_DATE_LATE:
      return i18n.t('indicator-target-date-LATE')
    case INDICATOR_TARGET_DATE_UPCOMING:
      return i18n.t('indicator-target-date-UPCOMING')
    default:
      return targetDateType
  }
}

function formatIndicatorJustification(justification) {
  return i18n.t(`indicator-justification-${justification}`)
}

function formatIndicatorDifficulty(difficulty) {
  switch (difficulty) {
    case INDICATOR_DIFFICULTY_UNSET:
      return i18n.t('indicator-difficulty-UNSET')
    case INDICATOR_DIFFICULTY_EASY:
      return i18n.t('indicator-difficulty-EASY')
    case INDICATOR_DIFFICULTY_MEDIUM:
      return i18n.t('indicator-difficulty-MEDIUM')
    case INDICATOR_DIFFICULTY_HARD:
      return i18n.t('indicator-difficulty-HARD')
    default:
      return difficulty
  }
}

function formatProjectStatus(status) {
  switch (status) {
    case PROJECT_STATUS_ACTIVE:
      return i18n.t('project-status-active-text')
    case PROJECT_STATUS_INACTIVE:
      return i18n.t('project-status-inactive-text')
    case PROJECT_STATUS_FINISH:
      return i18n.t('project-status-finish-text')
    default:
      return ''
  }
}

function formatUserLanguage(language) {
  switch (language) {
    case USER_LANGUAGE_FRENCH:
      return i18n.t('user-language-french')
    case USER_LANGUAGE_ENGLISH:
      return i18n.t('user-language-english')
    default:
      return language
  }
}

function formatProvince(provinceCode) {
  return i18n.t(`province-code-${provinceCode}`)
}

export default {
  formatBusinessStatus,
  formatBusinessCategory,
  formatBusinessUserType,
  formatIndicatorStatus,
  formatIndicatorTargetDate,
  formatIndicatorJustification,
  formatIndicatorDifficulty,
  formatProjectStatus,
  formatUserLanguage,
  formatProvince
}
